export default "__VITE_PUBLIC_ASSET__467bb810__"